import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import App from './App.jsx';
import { AuthProvider } from './auth.jsx';
import './i18n.js';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
    <Toaster
      position="bottom-right"
      toastOptions={{
        style: {
          background: '#18181b',
          color: '#f4f4f5',
          border: '1px solid #27272a',
          fontSize: '13px',
        },
        success: { iconTheme: { primary: '#10b981', secondary: '#18181b' } },
        error: { iconTheme: { primary: '#ef4444', secondary: '#18181b' } },
      }}
    />
  </React.StrictMode>,
);
